import e from"styled-components";const i=e.div`
	position: relative;
	border-radius: ${({borderRadius:e})=>`${e}px`};
	padding: 28px 14px;
	overflow: hidden;
	height: 100%;
	box-sizing: border-box;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: url(${({imageUrl:e})=>e});
		background-position: center;
		background-size: cover;
		filter: blur(30px) brightness(0.8);
		z-index: 2;
	}
`,t=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	gap: 28px;
	z-index: 3;
	position: relative;
	height: 100%;
`,o=e.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 28px;
`,n=e.h1`
	margin: 0;
	color: #ffffff;
	font-weight: 500;
	text-align: center;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,r=e.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
`,d=e.img`
	object-fit: cover;
	border-radius: 9999px;
	object-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
`,s=e.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:e})=>e};
	background: ${({background:e})=>e};
	border-radius: 9999px;
	width: fit-content;
	box-sizing: border-box;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,c=e.span`
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	color: #ffffff;
`,a=e.div`
	opacity: 0.5;
	height: 20px;
`;export{a as CardArrowContainer,i as CardContainer,t as CardContent,o as CardContentContainer,r as CardFooter,n as CardHeading,d as CardImage,s as CardLabel,c as CardLinkText};
